import API from "../../../../app/api";

const FAQService = {
    async getBySlug(slug) {
        return API.get(`/policy/${slug}`);
    }
};

export const getFaqBanners = () => {
    return API.get("/pages/faq-banners");
};

export default FAQService;
